import React, { useContext } from "react";

import { DataContext } from "../../../../../../providers/GasCheckoutDataProvider";
import Checkbox from "../../../../../shared/forms/Checkbox";
import FormError from "../../../../../shared/forms/FormError";
import NewInput from "../../../../../shared/forms/NewInput";

const SepaPayment = () => {
    const dataContext = useContext(DataContext);
    const { paymentData, iban } = dataContext.data;
    const {
        setPaymentData,
        setIban,
        addFormError,
        clearFormError,
        hasFormErrorAt,
    } = dataContext.actions;

    const handleChange = (event) => {
        setPaymentData({
            ...paymentData,
            ...{ [event.target.name]: event.target.value },
        });
    };
    const handleSepaCheckboxChange = () => {
        setPaymentData({
            ...paymentData,
            ...{
                payment_sepa_direct_granted:
                    !paymentData.payment_sepa_direct_granted,
            },
        });
        clearFormError("payment_sepa_direct_granted");
    };

    const onIbanChange = (event) => {
        setIban(event.target.value);
    };

    return (
        <section>
            {paymentData.payment_payment_type === 1 && (
                <React.Fragment>
                    <NewInput
                        placeholder="Kontoinhaber"
                        name="payment_account_holder"
                        value={paymentData.payment_account_holder}
                        onChange={handleChange}
                        validation="name"
                        forceError={hasFormErrorAt("payment_account_holder")}
                        onError={() => addFormError("payment_account_holder")}
                        onErrorSolved={() =>
                            clearFormError("payment_account_holder")
                        }
                        withField
                    />
                    <NewInput
                        placeholder="Kreditinstitut"
                        name="payment_bank_name"
                        value={paymentData.payment_bank_name}
                        onChange={handleChange}
                        validation="company"
                        forceError={hasFormErrorAt("payment_bank_name")}
                        onError={() => addFormError("payment_bank_name")}
                        onErrorSolved={() =>
                            clearFormError("payment_bank_name")
                        }
                        withField
                    />
                    <NewInput
                        placeholder="IBAN"
                        name="iban"
                        value={iban}
                        onChange={onIbanChange}
                        validation="iban"
                        forceError={hasFormErrorAt("iban")}
                        onError={() => addFormError("iban")}
                        onErrorSolved={() => clearFormError("iban")}
                        withField
                    />
                    <div>
                        <Checkbox
                            checked={paymentData.payment_sepa_direct_granted}
                            onClick={handleSepaCheckboxChange}
                            label="SEPA Lastschriftmandat erteilt"
                        />
                        {hasFormErrorAt("payment_sepa_direct_granted") && (
                            <FormError message="Bitte erteilen Sie ein Mandat."></FormError>
                        )}
                    </div>
                </React.Fragment>
            )}
        </section>
    );
};

export default SepaPayment;
